export default class Accordions {
    constructor(element) {
        // Set Values
        this.element = element;
        this.accordions = this.element.querySelectorAll("[data-accordion]");
        
        // Call Functions
        this.init();
    }

    init() {
        // Activate First Accordion
        if( !("stayClosed" in this.element.dataset) )
            this.activateFirst();

        // Add Event Listener
        for(let i = 0;i<this.accordions.length;i++) {
            let toggle = this.accordions[i];
            if(this.accordions[i].querySelector('[data-toggle]'))
                toggle = this.accordions[i].querySelector('[data-toggle]');

            toggle.addEventListener('click', () => {
                const isOpen = this.accordions[i].classList.contains("is-open");

                // Call Functions
                this.closeAccordions();

                if( !isOpen )
                    this.openAccordion(i);
            });
        }
    }

    activateFirst() {
        this.openAccordion(0);
    }

    closeAccordions() {
        for(let i = 0;i<this.accordions.length;i++) 
            this.accordions[i].classList.remove("is-open");
    }

    openAccordion(index) {
        this.accordions[index].classList.add("is-open");
    }
}